import Create from 'containers/Centres/components/CentreTabs/EducatorStaffProfilesTab/Create';

export default { Create };
